import { useMemo } from 'react';
import { MdDescription, MdImage, MdInsertDriveFile } from 'react-icons/md';
import { Icon } from '@nbirl/nbi-common-ui-libs';

import {
  IMAGE_EXTENSIONS,
  TEXT_EXTENSIONS,
} from '../../../../shared/constants';

type FileExtensionIconProps = {
  extension: string;
  className?: string;
};

export const FileExtensionIcon = ({
  extension,
  className,
}: FileExtensionIconProps) => {
  const icon = useMemo(() => {
    if (IMAGE_EXTENSIONS.includes(extension)) {
      return <MdImage className={className} />;
    } else if (TEXT_EXTENSIONS.includes(extension)) {
      return <MdDescription className={className} />;
    }

    return <MdInsertDriveFile className={className} />;
  }, [className, extension]);

  return <Icon icon={icon} />;
};
